module.exports = __webpack_public_path__ + "img/product_desk_5.c6d65125.jpg";